import type { EndpointDef } from '@skynet/data-helpers';

/**
 * Central endpoint definitions — single source of truth for the Bot Commands API.
 *
 * This file drives:
 * - **Enhanced API**: computed endpoint keys in `enhanceEndpoints`
 * - **Hook re-exports**: clean name → generated name mapping
 * - **MSW mock factories**: HTTP method + URL path pattern
 *
 * When the OpenAPI spec changes and codegen regenerates, update this
 * file to keep everything in sync.
 */

/**
 * Endpoint definitions keyed by clean export name.
 *
 * Each entry maps a human-friendly name to:
 * - `generated` — the codegen-produced RTK Query endpoint name, derived from the OpenAPI operationId
 * - `method` — HTTP verb
 * - `path` — URL pattern (MSW-compatible `:param` syntax)
 */
export const BOT_COMMANDS_API_ENDPOINTS = {
  listBotCommands: {
    generated: 'botCommandsAdminControllerListBotCommandsV1',
    method: 'get',
    path: '/api/v1/admin/bot-commands',
  },
  getBotCommand: {
    generated: 'botCommandsAdminControllerGetBotCommandV1',
    method: 'get',
    path: '/api/v1/admin/bot-commands/:id',
  },
  createBotCommand: {
    generated: 'botCommandsAdminControllerCreateBotCommandV1',
    method: 'post',
    path: '/api/v1/admin/bot-commands',
  },
  updateBotCommand: {
    generated: 'botCommandsAdminControllerUpdateBotCommandV1',
    method: 'put',
    path: '/api/v1/admin/bot-commands/:id',
  },
  deleteBotCommand: {
    generated: 'botCommandsAdminControllerDeleteBotCommandV1',
    method: 'delete',
    path: '/api/v1/admin/bot-commands/:id',
  },
  restoreBotCommand: {
    generated: 'botCommandsAdminControllerRestoreBotCommandV1',
    method: 'post',
    path: '/api/v1/admin/bot-commands/:id/restore',
  },
} as const satisfies Record<string, EndpointDef>;

export type BotCommandsEndpointName = keyof typeof BOT_COMMANDS_API_ENDPOINTS;
